import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PRM } from '@reflact/prmacweb';

import { PackService } from './services/PackService';

@Injectable({
  providedIn: 'root'
})
export class IsModeratorGuard {
  constructor(private packService: PackService, private router: Router) { }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const pack = await this.packService.getCurrentPackage();
    let resolve = true;
    if ((pack.me as PRM.Observer).role !== 'moderator') {
      resolve = false;
      this.router.navigateByUrl('/observer/introduction/docs');
    }
    return resolve;
  }

}
